export default {"src":"/_next/static/media/idea-or-innovation.ec3b3024.svg","height":192,"width":192};